
export function  groupBy(xs, key) {
    return xs.reduce(function (rv, x) {
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
    }, {});
}

export function createSignedURLPayload(importedFile,uuid){
    let fileNames = [];
    //importedFiles.forEach(importedFile => {  // prepare json payload to submit.
        let data = {
            "contentType": importedFile.fileObject.type,
            "fileName": importedFile.fileObject.name
        }
        fileNames.push(data);
    //});
    let signedUrlmsg = {
        "requestID": uuid,
        "requestData": {
            "fileList": JSON.parse(JSON.stringify(fileNames))
        }
    }
    return signedUrlmsg;
}

